import React, { Component } from "react";
import { Link } from "react-router-dom";
class AboutPrivacyPolicy_SiteContent extends Component {
  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div className="themesflat-headings style-2 clearfix">
            <h2 className="heading">PRAVILA PRIVATNOSTI</h2>
            <div className="sep has-width w80 accent-bg clearfix" />
            <p
              className="sub-heading font-size-16 line-height-28 text-666 margin-top-27 letter-spacing-01"
              style={{ textAlign: "justify" }}
            >
              Updated at 2022-02-01 General Terms
              <br />
              <br />
              CityX Apps d.o.o., Ulica Janka Draškovića 21B, 10430 Samobor, OIB:
              44810033758 (u daljnjem tekstu: CityX ili Voditelj obrade),
              poštuje privatnost svake osobe čije osobne podatke obrađuje, te
              iste štiti kao strogo povjerljive. CityX kontinuirano poduzima
              odgovarajuće organizacijske, tehničke i administrativne sigurnosne
              mjere za zaštitu osobnih podataka koje obrađuje od svih
              predvidivih rizika. Sigurnost osobnih podataka naših Korisnika i
              klijenata nam je vrlo važna, stoga bismo Vas u nastavku željeli
              obavijestiti o tome koje osobne podatke i u koju svrhu CityX
              prikuplja, kako ih štiti, kao i koja su Vaša prava kao ispitanika.
              <br />
              <br />
              <b>I. OPĆE INFORMACIJE</b>
              <br />
              <br />
              Voditelj obrade i zakonska osnova
              <br />
              CityX obrađuje osobne podatke u skladu s odredbama Uredbe EU
              2016/679 Europskog parlamenta i Vijeća od 27. travnja 2016. o
              zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom
              kretanju takvih podataka (Opća uredba o zaštiti podataka, dalje u
              tekstu: GDPR), Zakona o provedbi Opće uredbe o zaštiti podataka
              (NN 42/2018) i ostalih važećih pravnih propisa koji uređuju
              predmetno područje. U smislu ovih Pravila privatnosti, fizičke i
              pravne osobe čiji se podaci obrađuju („ispitanici“ kako je
              određeno u GDPR) naznačeni su kao Korisnici.
              <br />
              <br />
              Načela zaštite osobnih podataka
              <br />
              CityX prilikom obrade osobnih podataka posebnu pažnju posvećuje
              načelima obrade osobnih podataka:
              <br />
              zakonitost, poštenost i transparentnost obrade: to znači da obrada
              treba biti u skladu s određenim pravnim temeljem, a načelima
              poštene i transparentne obrade zahtijeva se da je pojedinac
              informiran o postupku obrade i njegovim svrhama, te da je Voditelj
              obrade obvezan ispitaniku pružiti sve dodatne informacije
              neophodne za osiguravanje poštene i transparentne obrade uzimajući
              u obzir posebne okolnosti i kontekst obrade osobnih podataka;
              ograničavanje svrhe: to znači da podaci trebaju biti prikupljeni u
              posebne, izričite i zakonite svrhe te se dalje ne smiju obrađivati
              na način koji nije u skladu s tim svrhama; ali je moguća daljnja
              obrada u svrhe arhiviranja u javnom interesu, u svrhe znanstvenog
              ili povijesnog istraživanja ili u statističke svrhe; smanjenje
              količine podataka: to znači da podaci moraju biti primjereni,
              relevantni i ograničeni na ono što je nužno u odnosu na svrhe u
              koje se obrađuju; točnost: to znači da podaci moraju biti točni i
              prema potrebi ažurni; mora se poduzeti svaka razumna mjera radi
              osiguravanja da se osobni podaci koji nisu točni, uzimajući u
              obzir svrhe u koje se obrađuju, bez odlaganja izbrišu ili isprave;
              ograničenje pohrane: to znači da podaci moraju biti čuvani u
              obliku koji omogućuje identifikaciju ispitanika samo onoliko dugo
              koliko je potrebno u svrhe radi kojih se osobni podaci obrađuju;
              dulja razdoblja čuvanja su moguća samo ako će se osobni podaci
              obrađivati isključivo u svrhe arhiviranja u javnom interesu, u
              svrhe znanstvenog ili povijesnog istraživanja ili u statističke
              svrhe uz provedbu primjerenih mjera zaštite propisanih Uredbom;
              cjelovitost i povjerljivost: to znači da podaci moraju biti
              obrađivani na način kojim se osigurava odgovarajuća razina
              sigurnosti, uključujući zaštitu od neovlaštene ili nezakonite
              obrade te od slučajnog gubitka, uništenja ili oštećenja;
              <br />
              <br />
              <b>II. KOJE OSOBNE PODATKE KORISNIKA PRIKUPLJAMO?</b>
              <br />
              CityX obrađuje osobne podatke ispitanika koji pristupaju i koriste
              našu web-stranicu WWW.CITYX.HR, kao i osoba koje koriste usluge
              koje su dostupne putem naše Web-stranice i aplikacije (dalje
              zajednički: Korisnici). Osobni podaci Korisnika koji se obrađuju
              prikupljeni, u pravilu, su od samih Korisnika. Osobne podatke
              prikupljamo:
              <br />
              1. Korištenjem naše web-stranice
              <br />
              2. Prilikom prijave za korištenje svih aplikacija
              <br />
              <br />
              <br />
              1. Osobni podaci Korisnika koje prikupljamo prilikom pristupanja i
              korištenja naše Web-stranice i aplikacije
              <br />
              Prilikom registracije za korištenje naših usluga, prikupljamo
              sljedeće osobne podatke Korisnika:
              <br />
              i) Ime;
              <br />
              ii) Prezime;
              <br />
              iii) E-mail adresa;
              <br />
              iv) Broj telefona;
              <br />
              <br />
              Za što koristimo navedene osobne podatke (svrha)?
              <br />
              Navedene podatke koristimo kako bismo izvršili registraciju i/ili
              identifikaciju pojedinog Korisnika i kako bismo bili u mogućnosti
              pružati informacije vezano za naše korištenje naših usluga.
              <br />
              <br />
              <b>III. PRAVNA OSNOVA ZA OBRADU OSOBNIH PODATAKA</b>
              <br />
              Pravne osnove za obradu osobnih podataka Korisnika:
              <br />
              a) obrada je nužna za izvršavanje ugovora u kojem je Korisnik
              stranka ili kako bi se poduzele radnje na zahtjev Korisnika prije
              sklapanja ugovora;
              <br />
              Podaci prikupljeni temeljem navedene osnove koriste se kako bismo
              s Korisnikom moli zasnovati ugovorni odnos, odnosno, kako bismo
              mogli izvršavati obveze iz predmetnog ugovornog odnosa.
              <br />
              b) obrada je nužna radi poštovanja pravnih obveza voditelja
              obrade;
              <br />
              Podaci prikupljeni temeljem navedene osnove koriste se kako bi
              voditelj obrade zadovoljio pravne obveze koje nameću pozitivni
              propisi koji uređuju izdavanje računa za pružane usluge.
              <br />
              Ujedno, temeljem ove osnove obrađivati će se osobni podaci
              Korisnika u svrhu zadovoljavanja propisa koji uređuju pitanje
              pranja novca i financiranja terorizma.
              <br />
              Ukoliko CityX odluči provoditi obradu osobnih podataka u
              marketinške i promotivne, isti će prikupljati i obrađivati jedino
              na temelju ove zakonske osnove.
              <br />
              <br />
              <br />
              <b>IV. TRAJANJE OBRADE OSOBNIH PODATAKA</b>
              <br />
              S obzirom na osjetljivu narav usluga koje CityX pruža, svi podaci
              obrađeni sukladno zakonskim osnovama, a sve sukladno minimalno
              utvrđenim zakonskim rokovima čuvanja određenim propisima čuvati
              će:
              <br />
              a) temeljem Zakona o računovodstvu – 11 godina
              <br />
              b) temeljem Zakona o sprječavanju pranja novca i financiranju
              terorizma – 5 godina/10 godina
              <br />
              <br />
              <b>V. S KIME DIJELIMO OSOBNE PODATKE KORISNIKA</b>
              <br />
              Osobne podatke Korisnika možemo dijeliti sa sljedećim vrstama
              primatelja:
              <br />
              a) sa izvršiteljima obrade osobnih podatka prilikom pružanja naših
              usluga sukladno ovim Pravilima privatnosti, a s kojima imamo
              sklopljeni pravni posao kojim se garantira zaštita osobnih
              podataka Korisnika sukladno ovim Pravilima privatnosti i
              pozitivnim pravnim propisima koji osiguravaju zaštitu osobnih
              podataka fizičkih osoba;
              <br />
              b) sa pružateljima usluga-trećim stranama i partnerima koji nam
              pružaju usluge obrade podataka, poput, ali ne ograničavajući se na
              obradu plaćanja i druga pitanja plaćanja, financijske savjetodavne
              usluge, IT podrška itd. Sve takve stranke obvezne su koristiti
              osobne podatke Korisnika sukladno ovim Pravilima privatnosti i
              pozitivnim pravnim propisima koji osiguravaju zaštitu osobnih
              podataka fizičkih osoba;
              <br />
              c) sa bilo kojim nadležnim tijelom, regulatornim tijelom, vladinom
              agencijom, pravosudnim organom, sudom, arbitražnim sudom ili
              trećom stranom za koju smatramo da je otkrivanje potrebno i
              opravdano
              <br />
              (i) radi zadovoljenja obveze propisane pozitivnima pravnim
              propisima;
              <br />
              (ii) radi ostvarivanja, uspostavljana ili obrane prava Voditelja
              obrade;
              <br />
              (iii) radi zaštite vitalnih interesa Voditelja obrade i/ili
              interesa bilo koje druge osobe kada je to zakonski opravdano
              <br />
              e) S bilo kojom drugom osobom, poput klijenata i trećih strana, uz
              vaš pristanak za takvo otkrivanje.
              <br />
              <br />
              <b>VI. KAKO ŠTITIMO OSOBNE PODATKE KORISNIKA?</b>
              <br />
              CityX aktivno provodi tehničke, fizičke i administrativne mjere
              sigurnosti u svrhu pružanja visoke razine zaštite osobnih podataka
              Korisnika od gubitka, zlouporabe, neovlaštenog pristupa,
              otkrivanja i promjena. Sigurnosne mjere uključuju vatrozidove
              (Firewalls), enkripciju podataka, fizičke kontrole pristupa našim
              podatkovnim centrima i ograničavanjem ovlaštenja za pristup
              osobnim podacima.
              <br />
              <br />
              <b>VII. PRAVA KORISNIKA KAO ISPITANIKA</b>
              <br />
              Prava Korisnika kao ispitanika u smislu GDPR-a vezana uz obradu
              osobnih podataka su slijedeća:
              <br />
              Pravo na pristup – Korisnik ima pravo dobiti od CityX potvrdu
              obrađuju li se osobni podaci koji se odnose na nju/njega odnose
              te, ako se takvi osobni podaci obrađuju, pristup osobnim podacima
              i sljedećim informacijama: svrsi obrade, kategorijama osobnih
              podataka o kojima je riječ, primateljima ili kategorijama
              primatelja osobnih podataka, razdoblju u kojem će osobni podaci
              biti pohranjeni, informacije o pravima i izvorima podataka ako
              nisu prikupljeni od Korisnika. Ako se osobni podaci Korisnika
              prenose i obrađuju izvan EU, Korisnik ima pravo na informaciju o
              odgovarajućim zaštitnim mjerama. Kad je to moguće, Korisnik može
              dobiti kopiju osobnih podataka koji se obrađuju.
              <br />
              Pravo na ispravak – Korisnik ima pravo na ispravak netočnih
              osobnih podataka koji se na njega/nju odnose, a koji ispravak smo
              dužni provesti bez nepotrebnog odgađanja. Uzimajući u obzir svrhe
              obrade, Korisnik ima pravo dopuniti nepotpune osobne podatke, među
              ostalim i davanjem dodatne izjave.
              <br />
              Pravo na brisanje („pravo na zaborav”) – Korisnik ima pravo na
              brisanje osobnih podataka koji se na nju/njega odnose, bez
              nepotrebnog odgađanja, ako ne postoji zakoniti razlog za daljnju
              obradu tih podataka (ako podaci više nisu nužni u odnosu na svrhe
              za koje su obrađivani i ne postoji kakva zakonska obveza
              pohranjivanja/čuvanja osobnih podataka).
              <br />
              Pravo na ograničenje obrade - Korisnik ima pravo na ograničenje
              obrade svojih osobnih podataka u sljedećim situacijama: ako
              osporava točnost; ako obrada nije zakonita, a protivi se brisanju;
              ako ih traži radi postavljanja, ostvarivanja ili obrane pravnih
              zahtjeva, a CityX nisu potrebni za obradu; ako je uložen prigovor
              vezano za obradu Korisnikovih osobnih podataka i čeka potvrdu.
              <br />
              Pravo na prenosivost podataka – Korisnik ima pravo podatke koji se
              odnose na nju/njega zaprimiti u strukturiranom, uobičajeno
              upotrebljavanom i strojno čitljivom formatu i prenijeti ih drugom
              pružatelju usluga tj. voditelju obrade podataka, ako su ispunjeni
              sljedeći uvjeti: obrada se temelji na Korisničkoj privoli ili na
              ugovoru i uz to se provodi automatiziranim putem. Prilikom
              ostvarivanja svojih prava na prenosivost podataka Korisnik ima
              pravo na izravni prijenos podataka drugome voditelju obrade ako je
              to tehnički izvedivo.
              <br />
              Pravo na prigovor - ako se obrada Korisnikovih osobnih podataka
              zasniva na ostvarenju legitimnih interesa CityX, Korisnik ima
              pravo u svakom trenutku uložiti prigovor na takvu obradu osobnih
              podataka u mjeri u kojoj se obrada odnosi na njegove podatke.
              <br />
              <br />
              Ostvarenje prava Korisnika kao ispitanika:
              <br />
              Za sva pitanja i zahtjeve u svezi s osobnim podacima, molimo
              kontaktirajte CityX službenika zaštite podataka na:
              <br />
              e-mail: katarina@cityx.hr
              <br />
              Upite i zahtjeve obraditi ćemo bez nepotrebnog odgađanja i u
              skladu sa zakonskim obvezama te ćemo Vas informirati o mjerama
              koje smo poduzeli.
              <br />
              Ukoliko smatrate da CityX postupa s Vašim podacima na nezakonit
              način te isto ne možete riješiti u suradnji s nama, imate pravo
              uložiti prigovor Nadzornom tijelu (Agencija za zaštitu osobnih
              podataka – AZOP).
              <br />
              <br />
              <b>
                VIII. PRAVA ISPITANIKA KADA OSOBNI PODACI NISU DOBIVENI OD
                ISPITANIKA
              </b>
              <br />
              U slučajevima prikupljanja i obrade osobnih podataka navedenim u
              točci II.6. Voditelj obrade može prikupiti i obrađivati osobne
              podatke trećih osoba – ispitanika koji su dobiveni od Korisnika.
              Sukladno čl. 14. GDPR, Voditelj obrade osigurava sva prava
              ispitanika kada su osobni podaci ispitanika dobiveni od Korisnika
              kao i kada se radi o Korisniku kao ispitaniku, te su sva prava,
              obveze, rokovi, uvjeti i informacije navedene u ovim Pravilima
              privatnosti u cijelosti primjenjiva i dostupna trećim osobama-
              ispitanicima čiji su osobni podaci dobiveni od Korisnika. Obveza
              je Korisnika da upozori i uputi treću osobu-ispitanika čije osobne
              podatke proslijedio na obradu Voditelju obrade na sadržaj ovih
              Pravila privatnosti i prava sadržana u njima.
              <br />
              <br />
              <b>IX. IZMJENE I DOPUNE POLITIKE PRIVATNOSTI</b>
              <br />
              CityX može povremeno i prema svom vlastitom nahođenju ažurirati,
              mijenjati i dopunjavati ovu Politiku privatnosti kao odgovor na
              promjenu pravnog, tehničkog ili poslovnog razvoja. Kada ažuriramo,
              mijenjamo ili dopunjavamo svoju Politiku privatnosti, poduzeti
              ćemo odgovarajuće mjere kako bismo obavijestili Korisnike, u
              skladu sa značajem promjena koje unesemo. Izmijenjena Pravila o
              privatnosti stupaju na snagu sa datumom objave.
              <br />
              <br />
            </p>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={60}
          data-smobile={60}
        />
      </div>
    );
  }
}

export default AboutPrivacyPolicy_SiteContent;
